import React from 'react';
import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingTextWithActions from 'molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';

interface FailureMessageProps {
  onButtonClick: () => void;
}

const FailureMessage = ({ onButtonClick }: FailureMessageProps): JSX.Element => (
  <Stack>
    <HeadingAndSupportingTextWithActions
      direction='column'
      gap='spacing-xl'
      heading={{
        text: 'Something went wrong!',
        type: 'heading',
        size: 'lg',
        textAlign: 'center',
      }}
      supportingText={{
        text: 'Please, try again later.',
        type: 'paragraph',
        size: 'md',
        textAlign: 'center',
      }}
      actions={
        <Stack
          marginTop='spacing-xl'
          justify='center'
          align='center'
          maxWidth='width-fit-content'
          margin={['spacing-none', 'spacing-auto']}
        >
          <Button
            variant='primary'
            size='md'
            onClick={onButtonClick}
          >
            Return to home
          </Button>
        </Stack>
      }
    />
  </Stack>
);

export default FailureMessage;
